/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import './stylesModal.css';
import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Dialog } from 'primereact/dialog';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { FaExclamationTriangle } from 'react-icons/fa';
import { atuatualizarLogUpSell, buscarPlanosPassiveisUpSell } from '../../../services/upSell';
import { atualizarStatusNoFluxo, formatarDetalhesComparacao, formatarEmDinheiro, statusEnum, validarNovoCep } from '../funcoesUpSell';
import { showMessageAlert, showMessageError, showMessageSuccess } from '../../others/toastr';
import { criptObjectOnLocalStorage, decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../../modulos/cripotografia/criptoStorage';
import getTipoColaborador from '../../../helpers/getTipoColaborador';

const ModalPlanosCompativeis = ({
    handleCloseModal,
    dadosVendedor,
    inscricao,
    contratoSelecionado
}) => {
    const [planos, setPlanos] = useState([]);
    const [verScrollpanel, setVerScrollpanel] = useState(false);
    const [infoPlanoSelecionado, setInfoPlanoSelecionado] = useState('');
    const [cepEditado, setCepEditado] = useState('');
    const [cepAlterado, setCepAlterado] = useState();
    const [codigoIbge, setCodigoIbge] = useState();
    const [infoPlanoAtual, setInfoPlanoAtual] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [showCardCep, setShowCardCep] = useState(false);
    const [subGrupoSelecionadoUpSell, setSubGrupoSelecionadoUpSell] = useState(true);
    const [tamanhoCarrosselPlanos, setTamanhoCarrosselPlanos] = useState({
        numVisible: 3,
        numScroll: 3
    });
    const codigoVendedor = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
    const tipoColaborador = getTipoColaborador(decriptObjectOnLocalStorage('PERM'));
    const history = useHistory();
    const responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 2,
            numScroll: 2
        }
    ];

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                localStorage.removeItem('cep_associado_up_sell');

                const subGrupo = contratoSelecionado.subGrupo?.trim() ?? contratoSelecionado.subGrupoOrigem?.trim();
                const codCidade = codigoIbge || contratoSelecionado.cidade;

                if (subGrupo && codCidade) {
                    const areaAtuacao = decriptoLocalStorage('area')?.decriptoValue;
                    const buscarPlanosComparar = await buscarPlanosPassiveisUpSell(
                        codCidade,
                        subGrupo,
                        areaAtuacao
                    );

                    if (buscarPlanosComparar?.data?.length < 2) {
                        showMessageAlert('warning', 'Não foram encontrado dados baseado nesta inscrição com esta localidade', 'toast-top-center');
                        setTimeout(() => {
                            handleCloseModal();
                        }, 3000);
                    }

                    buscarPlanosComparar?.data?.length > 1 && codigoIbge && (criptObjectOnLocalStorage('cep_associado_up_sell', JSON.stringify(cepAlterado)));

                    const planoAtualObj = buscarPlanosComparar.data.find(item => item.planoAtual === true);
                    const planosComparacao = buscarPlanosComparar.data.filter(plano => !plano.planoAtual);

                    if (planosComparacao.length < 4) {
                        setTamanhoCarrosselPlanos({
                            numVisible: planosComparacao.length,
                            numScroll: planosComparacao.length
                        });
                    }

                    setPlanos(planosComparacao);
                    setInfoPlanoAtual(formatarDetalhesComparacao(planoAtualObj));
                }

                setIsLoading(false);
            } catch (_error) {
                setIsLoading(false);
            }
        })();
    }, [codigoIbge]);

    const planoTemplate = plano => (
        <div className="plano-details">
            <div className="p-grid p-nogutter">
                <div className="p-col-12">
                    <div className="plano-title">Plano: {plano.subgrupo}</div>
                </div>
                <div className="p-col-12 plano-data">
                    <div className="plano-subtitle">Descricão: {plano.descricao}</div>
                    <div className="plano-price">Valor Mensal: {formatarEmDinheiro(plano.mensalidade)}</div>
                </div>
                <div className="car-buttons">
                    <Button
                        icon="pi pi-search"
                        className="p-button-secondary"
                        label="Comparar planos"
                        onClick={() => exibirCardComparacao(plano.subgrupo)}
                    />
                </div>
            </div>
        </div>
    );

    const exibirCardComparacao = planoSelecionado => {
        const planoSelecionadoInfo = planos.find(plano => plano.subgrupo === planoSelecionado?.trim());

        setInfoPlanoSelecionado(formatarDetalhesComparacao((planoSelecionadoInfo)));
        setSubGrupoSelecionadoUpSell(planoSelecionadoInfo.subgrupo?.trim());
        setVerScrollpanel(true);
    };

    const paginaEdicaoAssociado = async () => {
        const dadosVendedor = {
            inscricao: Number(inscricao),
            tipo: tipoColaborador,
            codigo: codigoVendedor
        };

        let body = {
            subGrupoDestino: subGrupoSelecionadoUpSell
        };

        if (codigoIbge) {
            body = {
                ...body,
                cidadeDestino: codigoIbge
            };
        }

        await atuatualizarLogUpSell(dadosVendedor, body);
        history.push({
            pathname: `/editar-contrato/${inscricao}`,
            state: { subGrupoSelecionadoUpSell }
        });
    };

    const desistenciaCliente = async () => {
        handleCloseModal();

        const result = await Swal.fire({
            title: 'O usuário desistiu da aquisição para o UpSell?',
            text: 'Se confirmar, este contrato não estará mais disponível para adição do UpSell. Você tem certeza que o usuário  não quer adiquirir o UpSell?',
            showCancelButton: true,
            confirmButtonColor: '#0d730d',
            cancelButtonColor: '#1b42cd',
            cancelButtonText: 'Não',
            confirmButtonText: 'Sim'
        });

        if (result.isConfirmed) {
            try {
                setIsLoading(true);

                const infoVendedor = {
                    inscricao,
                    tipo: dadosVendedor.tipoColaborador,
                    codigo: dadosVendedor.codigoVendedor
                };

                const body = {
                    status: statusEnum.recusado
                };

                await atualizarStatusNoFluxo(infoVendedor, body);

                showMessageSuccess('Sucesso', 'Desistencia do usuário cadastrado com sucesso!', 'toast-top-center');
                setIsLoading(false);
                window.location.reload();
            } catch (_error) {
                showMessageError(('Error', ' Erro ao Cadastrar Desistencia do usuário!'));
            }
        }
    };

    const desistenciaVendedor = async () => {
        handleCloseModal();

        const result = await Swal.fire({
            title: 'Desvincular o contrato?',
            text: 'Se confirmar, este contrato estará disponível para outros vendedores realizarem o UpSell. Você tem certeza que deseja liberar o contrato?',
            showCancelButton: true,
            confirmButtonColor: '#0d730d',
            cancelButtonColor: '#1b42cd',
            cancelButtonText: 'Não',
            confirmButtonText: 'Sim'
        });

        if (result.isConfirmed) {
            try {
                setIsLoading(true);

                const infoVendedor = {
                    inscricao,
                    tipo: dadosVendedor.tipoColaborador,
                    codigo: dadosVendedor.codigoVendedor
                };

                const body = {
                    status: statusEnum.liberado
                };

                await atualizarStatusNoFluxo(infoVendedor, body);

                showMessageSuccess('Sucesso', 'Contrato desvinculado com sucesso!', 'toast-top-center');

                setIsLoading(false);
                window.location.reload();
            } catch (_error) {
                showMessageError(('Error', ' Erro ao Desvincular contrato ao colaborador!'));
            }
        }
    };

    const fecharCardCep = () => {
        setShowCardCep(false);
        setCepEditado('');
    };

    const validarEAtualizarNovoCep = async () => {
        const cepAlterado = await validarNovoCep(cepEditado, fecharCardCep);

        setCepAlterado(cepAlterado);
        setCodigoIbge(cepAlterado.CodigoIbge);
    };

    const footerCardeCep = () => (
        <div>
            <Button
                label="Salvar novo Cep"
                icon="pi pi-check"
                className='p-button-success p-button-rounded'
                onClick={validarEAtualizarNovoCep}
            />
            <Button
                label="Voltar"
                icon="pi pi-times"
                className="p-button-warning p-button-rounded"
                onClick={() => fecharCardCep()}
            />
        </div>
    );

    return (
        <>
            {isLoading && (
                <i className="pi pi-spin pi-spinner is-loading" />
            )}
            {
                verScrollpanel ? (
                    <>
                        <div className="content-section">
                            <div className="titulo-modal">
                                <h3>Regras em Comparativo de planos</h3>
                            </div>
                        </div>

                        <div className="content-section implementation scrollpanel-demo">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-6">
                                    <h2 className="centered-title">Regras plano Atual</h2>
                                    <ScrollPanel>
                                        <div className='plano-Atual'>
                                            {infoPlanoAtual}
                                        </div>
                                    </ScrollPanel>
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <h2 className="centered-title">Regras plano Destino</h2>
                                    <ScrollPanel className="custombar1">
                                        <div className="plano-selecionado">
                                            {infoPlanoSelecionado}
                                        </div>
                                    </ScrollPanel>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="carousel-demo">
                        <Carousel
                            header={<h2>Planos Disponíveis</h2>}
                            value={planos}
                            itemTemplate={planoTemplate}
                            numVisible={tamanhoCarrosselPlanos.numVisible}
                            numScroll={tamanhoCarrosselPlanos.numScroll}
                            responsiveOptions={responsiveOptions}
                        />
                    </div>
                )
            }

            <div className='rotape-modal-principal'>
                {verScrollpanel ? (
                    <>
                        <p className='info-regras-planos'>
                            <FaExclamationTriangle className="icon-warning" />
                            As informações apresentadas acima são baseadas nos subgrupos base.
                        </p>
                        <p className='info-regras-planos'>
                            Condições dos planos podem variar conforme a região dos planos atual e destino.
                        </p>
                        <div className='botao_voltar_prossegur'>
                            <Button
                                icon="pi pi-arrow-circle-left"
                                className="p-button-secondary"
                                label="Voltar"
                                onClick={() => setVerScrollpanel(false)}
                            />
                            <Button
                                icon="pi pi-check"
                                className="p-button-info"
                                style={{
                                    marginLeft: '8px'
                                }}
                                label="Prosseguir"
                                onClick={paginaEdicaoAssociado}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="dialog-demo">
                            <Dialog
                                header="Edição de CEP residencial"
                                visible={showCardCep}
                                style={{ width: '50vw' }}
                                onHide={fecharCardCep}
                                position={'center'}
                                blockScroll
                                footer={footerCardeCep()}
                            >
                                <p className='title-input-novo-cep'>Por favor, digite o novo CEP:</p>
                                <InputMask
                                    className="input-cep"
                                    name="CEPResid"
                                    mask="99999-999"
                                    value={cepEditado}
                                    onChange={e => setCepEditado(e.target.value)}
                                />
                                <p className='label-info-cep'>
                                    Disponibilidade de Planos pode variar de acordo com CEP informado.</p>
                            </Dialog>
                        </div>

                        <div className='botao_desistencia_libera'>
                            <Button
                                icon="pi pi-pencil"
                                className="p-button-rounded"
                                style={{
                                    backgroundColor: '#808080',
                                    border: 'none'
                                }}
                                label="Editar Cep Residencia?"
                                onClick={() => setShowCardCep(true)}
                            />

                            <Button
                                icon="pi pi-calendar-times"
                                className="p-button-rounded"
                                style={{
                                    marginLeft: '8px',
                                    backgroundColor: 'antiquewhite',
                                    border: 'none',
                                    color: '#000'
                                }}
                                label="Desistencia Cliente"
                                onClick={desistenciaCliente}
                            />

                            <Button
                                icon="pi pi-lock-open"
                                className="p-button-secondary p-button-rounded"
                                style={{
                                    marginLeft: '8px'
                                }}
                                label="Liberar Contrato"
                                onClick={desistenciaVendedor}
                            />

                        </div>
                    </>
                )}
                <Button
                    icon="pi pi-times"
                    className="p-button-warning"
                    style={{
                        marginLeft: '8px',
                        borderRadius: '5px'
                    }}
                    label="Sair"
                    onClick={handleCloseModal}
                />
            </div>
        </>
    );
};

export default ModalPlanosCompativeis;
